import { operationalShiftAt, shiftInterval, UNSCHEDULED_PLAN_SHIFT_CODE } from "../../../shared/production/plan-window";

export const today = (now = new Date()) => {
  return operationalShiftAt(now.getTime()).date;
};

export const dateTime = (value: string) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : new Intl.DateTimeFormat("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
};

export const planDate = (value?: string | null) => {
  const match = value?.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : "Tarih yok";
};

export const plannedDateTime = (date: string, time: string, nextDay = false) => {
  const value = new Date(`${date}T${time}:00`);
  if (nextDay) value.setDate(value.getDate() + 1);
  return value.toISOString();
};

export const shiftHours = (shiftCode?: string) =>
  shiftCode === UNSCHEDULED_PLAN_SHIFT_CODE
    ? "Saat belirtilmemiş"
    : shiftCode?.startsWith("1")
    ? "00:00–08:00"
    : shiftCode?.startsWith("2")
      ? "08:00–16:00"
      : "16:00–00:00";

export const activeShiftAt = (date = new Date()) => operationalShiftAt(date.getTime()).shiftCode;

export const shiftEndTimestamp = (date: string, shiftCode: string) => {
  return shiftInterval(date, shiftCode).end;
};

export const plannedDuration = (hours: number | null) => {
  if (hours == null) return "Süre belirtilmemiş";
  const totalMinutes = Math.max(1, Math.round(hours * 60));
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return [wholeHours ? `${wholeHours} sa` : "", minutes ? `${minutes} dk` : ""]
    .filter(Boolean)
    .join(" ");
};

export const durationBetween = (start: string, end: string | null) => {
  const milliseconds = Math.max(
    0,
    new Date(end ?? Date.now()).getTime() - new Date(start).getTime(),
  );
  const totalMinutes = Math.floor(milliseconds / 60_000);
  const seconds = Math.floor((milliseconds % 60_000) / 1_000);
  return totalMinutes ? `${totalMinutes} dk ${seconds} sn` : `${seconds} sn`;
};

export const operatorDuration = (milliseconds: number) => {
  const totalMinutes = Math.max(0, Math.floor(milliseconds / 60_000));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours ? `${hours} sa ${String(minutes).padStart(2, "0")} dk` : `${minutes} dk`;
};
